import React, { Component } from 'react';
import classes from './QuizCounter.css';
import * as actions from '../../store/actions/index';

import ReactGA from 'react-ga';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
//import axios from 'axios';


class QuizCounter extends Component {

	constructor(props) {
		super(props)
		this.state = {
			result: 3,
			elapsedMinutes: "00",
			elapsedSeconds: "00",
			qStage: null
		}
		this.countDownInterval=null;
		this.canvas=null;
		this.ctx=null;
		this.startDate=null;
		this.tOut=null;
	}

/*
	componentDidMount () {
		//console.log("quizCounter mounted");
		//this.startCountDown();
	}
*/
	componentWillReceiveProps(nextProps) {
		//console.log('quizCounter received props',nextProps.quizStage);
		if ( (nextProps.quizStage==="started" || nextProps.quizStage==="prep") && nextProps.quizStage!==this.state.qStage) {
			this.setState({
				qStage: nextProps.quizStage
			})
			if (nextProps.quizStage==="prep") {
				this.startCountDown();

			} else if (nextProps.quizStage==="started") {
				if (nextProps.activeQuestion===1) {
					this.startTimeCount();
				}

				const nextResult = Math.round(nextProps.answers/nextProps.totalQuestions*10)
				this.setState({
					...this.state,
					result:nextResult
				});
				this.drawGaugeValue(nextResult/10);
			} 
		}
	}

	startCountDown = () => {
		//console.log("quiz counter starting countdown", this.countDownInterval);
		this.countDownInterval = setInterval(()=>{
			let oldcnt = this.state.result;
			if (oldcnt > 0) {
				this.setState({
					...this.state,
					result: oldcnt-1
				});
			} else {
				clearInterval(this.countDownInterval);

				ReactGA.event({
					category: 'Quiz Action',
					action: 'Started'
				});
	

				// start QUIZ
				// trebalo bi poceti countup tek kada se odbije resp od baze
				//axios.
				this.props.onQuizStart(this.props.quizSession,this.props.userID,'start');
				//this.startTimeCount();
				//this.props.onChangeQuizState('started');
			}
		},1000);
		this.drawGaugeValue(0);
		//console.log("quiz counter started countdown!", this.countDownInterval);
	}

	startTimeCount = () => {
		this.startDate =  Math.floor(Date.now() / 1000);
		this.timeCount();
	}

	componentWillUnmount () {
		clearTimeout(this.tOut);
	}

	timeCount = () => {
		var now = Math.floor(Date.now() / 1000);
		var diff = now - this.startDate; // diff in seconds between now and start
		var m = Math.floor(diff / 60); // get minutes value (quotient of diff)
		var s = Math.floor(diff % 60); // get seconds value (remainder of diff)
		m = this.checkTime(m); // add a leading zero if it's single digit
		s = this.checkTime(s); // add a leading zero if it's single digit
		this.tOut = setTimeout(this.timeCount, 500);

		this.setState({
			...this.state,
			elapsedMinutes: m,
			elapsedSeconds: s
		})

	}

	checkTime (i) {
		if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
		return i;
	}	

	drawGaugeValue = (val) => {
		//console.log(val);
		/*var currentValue = 1;
			100 /
			(game.state.numberOfQuestions / (game.state.correctAnswers - 1)) /
			100;
			*/
		/*var nextValue = 2;*/
		/*currentValue + 100 / game.state.numberOfQuestions / 100;*/

			var canvas = this.refs.canvas;
			var ctx = canvas.getContext("2d");
			var imd = null;

			var startRad = 0.75;
			var totalRads = 1.5;

			var sAngle = Math.PI * startRad;

			ctx.beginPath();
			ctx.strokeStyle = "#eaeaea";
			ctx.lineCap = "round";
			ctx.closePath();
			ctx.fill();
			ctx.lineWidth = 40.0;
			ctx.arc(
				190,
				185,
				145,
				sAngle,
				(totalRads * 1 + startRad) * Math.PI,
				false
				);
			ctx.stroke();


			ctx.beginPath();
			ctx.strokeStyle = "#47338f";
			ctx.lineCap = "round";
			ctx.closePath();
			ctx.fill();
			ctx.lineWidth = 10.0;

			ctx.beginPath();
			if (val) {
			ctx.arc(
				190,
				185,
				145,
				sAngle,
				(totalRads * val + startRad) * Math.PI,
				false
				);
				ctx.stroke();
			}

			imd = ctx.getImageData(0, 0, 378, 334);

			ctx.putImageData(imd, 0, 0);

			this.refs.imd.src = canvas.toDataURL("image/png");
		};


	render () {

		const diffColor = this.props.quizStage==="started" ? 'startedColor' : '';

		return (
			<div className={classes.quizCounterHolder}>
				<div className={classes.counter + ' ' + classes[diffColor]} >
					{this.state.elapsedMinutes}:{this.state.elapsedSeconds}
				</div>
				<div className={classes.image}>
					<div className={classes.scoreHolder}>
						<img ref="imd" src="" alt="" className={classes.clone}/>
						<canvas className={classes.canvas} ref="canvas" width={378} height={334} />
						<div className={classes.percentage}>
							{this.state.result}
						</div>
					</div>
				</div>
			</div>
		);
	}
};

const mapStateToProps = state => {
	return {
		quizStage: state.quiz.quizStage,
		answers: state.quiz.answers,
		questions: state.quiz.numberOfQuestions,
		activeQuestion: state.quiz.activeQuestion,
		quizSession: state.quiz.quizSession,
		totalQuestions: state.quiz.numberOfQuestions,
		userID: state.auth.userId,
	};
}

const mapDispatchToProps = dispatch => {
	return {
		onChangeQuizState: (newStage) => dispatch (actions.quizChangeStage(newStage)),
		onQuizStart: (qSess,uid,t) => dispatch (actions.quizPushAction(qSess,uid,t))
	}
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizCounter));


// WEBPACK FOOTER //
// ./src/components/QuizCounter/QuizCounter.js